import React, { useEffect } from 'react';
import './HeaderFooter.css';

const Footer = () => {
  useEffect(() => {
    // Ajout du script après le montage du composant
    const script1 = document.createElement("script");
    script1.id = "_wauhf6";
    script1.innerHTML = `var _wau = _wau || []; _wau.push(["small", "formulaire44", "hf6"]);`;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = "//waust.at/s.js";
    script2.async = true;
    document.body.appendChild(script2);
  }, []);

  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} HeyPulse | Tous droits réservés</p>

      {/* Le plugin est masqué ici */}
      <div style={{ display: 'none' }}>
        <script id="_wauhf6">
          var _wau = _wau || [];
          _wau.push(["small", "formulaire44", "hf6"]);
        </script>
        <script async src="//waust.at/s.js"></script>
      </div>
    </footer>
  );
};

export default Footer;
